import React from "react"
import TextCell, { TextCellProps } from "./TextCell"
import { ContentfulBicycleModel } from "../../../../graphql-types"

type HeightCellProps = TextCellProps & {
  bike: ContentfulBicycleModel
}

const toFeet = (inches?: number | null) =>
  inches ? `${Math.floor(inches / 12)}'${inches % 12}"` : "N/A"

export default function HeightCell({
  bike,
  value: _value,
  ...props
}: HeightCellProps) {
  const minHeight = bike.bodyFitMinHeight
  const maxHeight = bike.bodyFitMaxHeight
  return (
    <TextCell
      {...props}
      value={`${toFeet(minHeight)} to ${toFeet(maxHeight)}`}
    />
  )
}
